import React from "react";
const actionLog = {};
export const createReducer = (reducerFn, logger) => (state, action) => {
    if (actionLog[logger.group] !== action) {
        logger.log("[REDUCER]", action);
    }
    else {
        logger.log("[REDUCER]", "Double-invoked action : This could be desired, or possibly result in bad state update. This will mainly happen when you dispatch multiple actions in the same process method, this is unavoidable. Make sure the reducer is idempotent, and combine things like arrays in the process... For more info: https://reactjs.org/docs/strict-mode.html#detecting-unexpected-side-effects", action);
    }
    actionLog[logger.group] = action;
    return reducerFn(state, action);
};
export const createContext = (initialState, processCreator) => {
    const context = React.createContext({
        state: initialState,
        process: {},
    });
    return context;
};
export const useService = (deps, initialState, processCreator, reducer) => {
    let hotDeps;
    if (reducer) {
        const [state, dispatch] = React.useReducer(reducer, initialState);
        hotDeps = Object.assign(Object.assign({}, deps), { state,
            dispatch });
    }
    else {
        const [state, dispatch] = React.useState(initialState);
        hotDeps = Object.assign(Object.assign({}, deps), { state, dispatch: dispatch });
    }
    const process = processCreator(hotDeps);
    return {
        state: hotDeps.state,
        process: process,
    };
};
